import React from 'react';
//Material
import {makeStyles} from 'tss-react/mui';
import {createTheme, ThemeProvider} from '@mui/material/styles';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';

const theme = createTheme();
const useStyles = makeStyles()((theme) => ({
   paper: {
      opacity: 0.95,
      padding: theme.spacing(3, 2),
      marginTop: theme.spacing(4),
      display: 'flex',
      alignItems: 'center'
   },
   avatar: {
      display: 'inline-block',
      width: '120px',
      height: '120px',
      backgroundSize: 'cover',
      zIndex: -1
   },
   textoContenedor: {
      width: '100%',
      height: '190px',
      display: 'inline-block',
      textAlign: 'center'
   },
   h1: {
      marginTop: '0.2em',
      fontSize: '120px'
   }
}));

function NotFound({ceroSrc}) {
   const {classes} = useStyles();

   return (
      <Container component="main" maxWidth="lg">
         <Paper className={classes.paper}>
            <Grid container>
               <Grid item xs={12}>
                  <Typography variant="h3" gutterBottom align="center">
                     404: La página que estas buscando no esta aqui
                  </Typography>
               </Grid>
               <Grid item xs={12}>
                  <Typography
                     variant="subtitle1"
                     align="center"
                     color="textSecondary"
                     component="p"
                  >
                     Lo sentimos pero la pagina que estas buscando no existe, fue eliminada, cambio
                     de nombre, esta temporalmente inabilidata o necesitas iniciar sesión para
                     verla.
                  </Typography>
               </Grid>
               <Grid item xs={12} className={classes.textoContenedor}>
                  <h1 className={classes.h1}>
                     4
                     <Avatar
                        src={
                           ceroSrc ||
                           'https://cdn.shopify.com/s/files/1/1061/1924/products/5_grande.png?v=1571606116'
                        }
                        alt="0"
                        className={classes.avatar}
                     ></Avatar>
                     4
                  </h1>
               </Grid>
            </Grid>
         </Paper>
      </Container>
   );
}

export default NotFound;
